import React from 'react';
import { LinkData } from '../types';

interface Props {
  config: Record<string, any>;
  links: LinkData[];
}

export const MultiColumnLinks: React.FC<Props> = ({ config, links }) => {
  // Use correct field names from types.ts
  const {
    sectionHeading = '',
    columns = '3',
    maxLinksPerModule = 5,
    showViewMore = true,
    columnDivider = 'none',
    containerBackground = 'white',
  } = config;

  const numColumns = parseInt(columns, 10) || 3;

  // Split links into columns
  const linksPerColumn = Math.ceil(links.length / numColumns);
  const columnData: { links: LinkData[]; hasMore: boolean }[] = [];
  for (let i = 0; i < numColumns; i++) {
    const colLinks = links.slice(i * linksPerColumn, (i + 1) * linksPerColumn);
    columnData.push({
      links: colLinks.slice(0, maxLinksPerModule),
      hasMore: colLinks.length > maxLinksPerModule,
    });
  }

  // Get background color
  const getBgColor = () => {
    switch (containerBackground) {
      case 'gray':
        return '#f8fafc';
      case 'transparent':
        return 'transparent';
      default:
        return '#ffffff';
    }
  };

  // Get column divider style
  const getColumnStyle = (index: number): React.CSSProperties => {
    if (columnDivider === 'none' || index === numColumns - 1) return {};
    if (columnDivider === 'line') return { borderRight: '1px solid #e5e7eb' };
    if (columnDivider === 'shadow') return { boxShadow: '2px 0 4px rgba(0,0,0,0.05)' };
    return {};
  };

  return (
    <div style={{ background: getBgColor(), fontFamily: 'system-ui, -apple-system, sans-serif' }}>
      {sectionHeading && (
        <h2
          style={{
            color: '#1e3a5f',
            marginBottom: '1rem',
            fontSize: '1.25rem',
            fontWeight: 600,
            margin: '0 0 1rem 0',
          }}
        >
          {sectionHeading}
        </h2>
      )}
      <div style={{ display: 'grid', gridTemplateColumns: `repeat(${numColumns}, 1fr)`, gap: '1.5rem' }}>
        {columnData.map((col, colIndex) => (
          <div key={colIndex} style={{ paddingRight: '1rem', ...getColumnStyle(colIndex) }}>
            <h3 style={{ color: '#1e3a5f', fontSize: '1rem', fontWeight: 600, marginBottom: '0.5rem' }}>
              Column {colIndex + 1}
            </h3>
            <ul style={{ listStyle: 'none', margin: 0, padding: 0 }}>
              {col.links.map((link, i) => (
                <li key={i} style={{ padding: '0.3rem 0' }}>
                  <a href={link.url} style={{ color: '#2db77a', textDecoration: 'none' }}>
                    {link.title || link.anchorText || link.url}
                  </a>
                </li>
              ))}
            </ul>
            {showViewMore && col.hasMore && (
              <a
                href="#"
                style={{
                  display: 'inline-block',
                  marginTop: '0.5rem',
                  color: '#64748b',
                  textDecoration: 'none',
                  fontSize: '0.85rem',
                }}
              >
                View More
              </a>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};
